export default __webpack_public_path__ + "static/media/i004vp.80f07d90.webp";